<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17px" height="17px" viewBox="0 0 17 17" version="1.1">
    <g id="surface1">
      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(86.666667%,88.627452%,89.803922%);fill-opacity:1;" d="M 9.5625 5.84375 L 9.5625 3.71875 C 9.5625 3.132812 10.039062 2.65625 10.625 2.65625 L 11.6875 2.65625 L 11.6875 0 L 9.5625 0 C 7.800781 0 6.375 1.425781 6.375 3.1875 L 6.375 5.84375 L 4.25 5.84375 L 4.25 8.5 L 6.375 8.5 L 6.375 17 L 9.5625 17 L 9.5625 8.5 L 11.6875 8.5 L 12.75 5.84375 Z M 9.5625 5.84375 "/>
    </g>
  </svg>
</template>

<script>
export default {};
</script>
